document.addEventListener("DOMContentLoaded", function() {
  let last_rowElem = document.querySelector('#loading_next');
  let in_viewport = false;
      window.onscroll = function() {
      in_viewport = isInViewport(last_rowElem);
      if (in_viewport && window.infinite_scroll_firstTime) {
          window.infinite_scroll_firstTime = false;
          var endlessScroll = new Ajaxinate({
              container: '#product-grid',
              pagination: '#loading_next'
          });
      }
  }

// Determine if an element is in the visible viewport
  function isInViewport(element) {
      var rect = element.getBoundingClientRect();
      var html = document.documentElement;
      return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || html.clientHeight) &&
          rect.right <= (window.innerWidth || html.clientWidth)
      );
  }
})

async function findMatchingAnchor() {
  history.scrollRestoration = 'manual';
  const productGrid = document.querySelector("#product-grid");
  if (!productGrid) {
    localStorage.setItem("page", window.location.href)
    return;
  }

  const baseUrl = window.location.href.split("?")[0];

  const referrer = localStorage.getItem("page");
  if (!referrer || !referrer.includes("/products/")) {
    return;
  }

  const baseDomain = window.location.origin;
  const productPath = referrer.replace(baseDomain, "");
  const matchingAnchor = document.querySelector(`a[href="${productPath}"]`);
  const lastPage = Number(document.querySelector('#product-grid').getAttribute('data-amount-pages'));
  let page = 2;
  let found = false;

  if(matchingAnchor){
    found = true;
    setTimeout(() => {
      matchingAnchor.closest('.grid__item').scrollIntoView({ behavior: "smooth", block: "center" });
    })
  }
  while (!found) {
    const url = `${baseUrl}?page=${page}`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        break;
      }

      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");

      const newContent = doc.querySelector("#product-grid");
      const newContentContainsLi = newContent.querySelector('li')
      if(!newContentContainsLi) {
        found = true;
        break;
      }
      if (newContent && newContentContainsLi) {
        const matchingAnchor = newContent.querySelector(`a[href="${productPath}"]`);
        if (matchingAnchor) {

          productGrid.insertAdjacentHTML("beforeend", newContent.innerHTML);

          const scrollToElement = document.querySelector(`a[href="${productPath}"]`).closest('.grid__item');
          if (scrollToElement) {
            const newUrl = `${window.location.pathname}?page=${page + 1}`;
            document.querySelector("#loading_next a").href = newUrl;

            if (page == lastPage){
              document.querySelector("#loading_next").remove()
            }

            scrollToElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
          found = true;

          break;
        }

        productGrid.insertAdjacentHTML("beforeend", newContent.innerHTML);
      } else {
        const newUrl = `${window.location.pathname}?page=${page + 1}`;
        document.querySelector("#loading_next a").href = newUrl;
        break;
      }
    } catch (error) {
      break;
    }

    page++;

  }
  localStorage.setItem("page", window.location.href)
}
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
findMatchingAnchor();
}
});
